import { styled } from '@mui/material/styles'
import TextField, { TextFieldProps } from '@mui/material/TextField'
import { Box, InputAdornment, Typography } from '@mui/material'
import i18n from 'i18n'
import React from 'react'

type MyInputProps = TextFieldProps & {
  max?: number
  type?: string
  maxLength?: number
  endAdornment?: React.ReactNode
}

const StyledTextField = styled(TextField)(({ theme }) => {
  const isRtl = i18n.dir() === 'rtl'

  return {
    '& .MuiOutlinedInput-root': {
      overflow: 'hidden',
      backgroundColor: theme.palette.card.primary,
      color: theme.palette.text.primary,
      '& fieldset': {
        borderColor: 'var(--color-border-overlay)'
      },
      '&:hover fieldset': {
        borderColor: 'var(--color-border-overlay)'
      },
      '&.Mui-focused fieldset': {
        borderColor: 'var(--color-border-overlay)'
      }
    },
    '& .MuiInputAdornment-positionEnd': {
      marginRight: isRtl ? 0 : 8,
      marginLeft: isRtl ? 8 : 0,
      maxHeight: 'none'
    },
    '& .MuiInputBase-input': {
      textAlign: isRtl ? 'right' : 'left',
      color: theme.palette.text.primary
    }
  }
})

const SizeTextFieldInput = (props: MyInputProps) => {
  const {
    max,
    maxLength,
    endAdornment,
    label,
    inputProps,
    InputProps,
    ...rest
  } = props

  const isRtl = i18n.dir() === 'rtl'

  return (
    <Box sx={{ position: 'relative' }}>
      {label ? (
        <Typography
          position={'absolute'}
          fontSize={'0.75rem'}
          color={'var(--color-text-secondary)'}
          sx={{
            top: -8,
            left: isRtl ? 'auto' : 14,
            right: isRtl ? 14 : 'auto',
            backgroundColor: 'var(--color-surface-card)',
            paddingLeft: '4px',
            paddingRight: '4px',
            zIndex: 1,
            pointerEvents: 'none'
          }}
        >
          {label}
        </Typography>
      ) : null}
      <StyledTextField
        {...rest}
        label={undefined}
        inputProps={{
          max,
          maxLength,
          ...inputProps
        }}
        InputProps={{
          ...InputProps,
          endAdornment: endAdornment ? (
            <InputAdornment position="end">{endAdornment}</InputAdornment>
          ) : (
            InputProps?.endAdornment
          )
        }}
        style={{ fontSize: '14px' }}
        type={props.type ?? 'number'}
      />
    </Box>
  )
}

export default SizeTextFieldInput
